(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["external-links"] && !Shopify.designMode) return;
  try {
    (function() {
  function isExternalLink(anchor) {
    if (!anchor.href) return false;
    try {
      var linkUrl = new URL(anchor.href, window.location.href);
      return linkUrl.origin !== window.location.origin;
    } catch (e) {
      return false;
    }
  }
  function updateExternalLinks(root) {
    var links = (root || document).querySelectorAll('a[href]');
    links.forEach(function(link) {
      if (isExternalLink(link)) {
        link.setAttribute('target', '_blank');
        var rel = (link.getAttribute('rel') || '').split(/[\s,]+/).filter(Boolean);
        if (rel.indexOf('noopener') === -1) rel.push('noopener');
        if (rel.indexOf('noreferrer') === -1) rel.push('noreferrer');
        link.setAttribute('rel', rel.join(' '));
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      updateExternalLinks();
    });
  } else {
    updateExternalLinks();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
